module.exports = __webpack_public_path__ + "img/arrow.b9893e8c.png";